export const COD_THANK_YOU_SECTION = {
  leftOffset: 0,
  topOffset: 1920,
  config: {
    events: {
      COD_THANK_YOU_OPEN: {
        style:
          'transition: top 0.5s cubic-bezier(0, 0, 0.2, 1); top: 0px; z-index: 40;',
      },
      COD_THANK_YOU_CLOSE: {
        style:
          'transition: top 0.5s cubic-bezier(0, 0, 0.2, 1) 0.3s; top: 1920px; z-index: 40;',
      },
    },
    initial: { style: 'top: 1920px;' },
    dynamicHighlight: 1,
    suggestedComponentTypes: ['cod-thank-you'],
  },
  width: 1080,
  height: 1920,
};

export const ROTATION_SECTION_CONFIG = {
  events: {
    SECTION_TIMER: {
      style: 'opacity: 1; transition: opacity 0.5s; z-index: 2;',
    },
  },
  initial: { style: 'opacity:0; z-index: -1;' },
  dynamicHighlight: 2,
};

export const COD_PROMO_CONFIG = {
  events: {
    COD_COMPLETE: {
      style: 'opacity: 0; transition: opacity 0.5s; z-index: -1;',
    },
    COD_ORDER_OPEN: {
      style: 'opacity: 1; transition: opacity 0.5s; z-index: 20;',
    },
  },
  initial: { style: 'opacity: 0; z-index: -1;' },
  dynamicHighlight: 1,
};

export const createDysComboPayload = (
  disclaimerAdjustment: number,
  isLeftCodPosition = true,
) => ({
  leftOffset: isLeftCodPosition ? 360 : 0,
  topOffset: disclaimerAdjustment,
  config: {
    events: {
      COD_COMPLETE: {
        style: 'opacity: 0; transition: opacity 0.6s; z-index: 25;',
      },
      DY_SUGGESTIONS_OPEN: {
        style: 'opacity: 1; transition: opacity 0.6s; z-index: 25;',
      },
    },
    initial: { style: 'opacity: 0; z-index: -1;' },
    dynamicHighlight: 1,
  },
  width: 720,
  height: 1320,
});

export const DYR_CONFIG = {
  dynamicHighlight: 0,
  initial: { style: 'opacity:1; transition: opacity 0.5s;' },
  suggestedComponentTypes: ['DYR', 'single-shelf'],
};

export const BASE_CONFIG = {
  initial: { style: 'opacity:1; transition: opacity 0.5s;' },
  dynamicHighlight: 0,
};

export const createCodDysPayload = (
  disclaimerAdjustment: number,
  isLeftCodPosition = true,
) => ({
  leftOffset: isLeftCodPosition ? -720 : 1080,
  topOffset: 1320 + disclaimerAdjustment,
  config: {
    events: {
      COD_COMPLETE: {
        style: `left: ${
          isLeftCodPosition ? -720 : 1080
        }px; transition: left 0.4s; z-index: 20;`,
      },
      DY_SUGGESTIONS_OPEN: {
        style: `left: ${
          isLeftCodPosition ? 360 : 0
        }px; transition: opacity 0.1s, left 1s cubic-bezier(.39,1.48,.38,.89) 1s; transition-delay: 0.2s; z-index: 20;`,
      },
    },
    initial: { style: `left: ${isLeftCodPosition ? -720 : 1080}px;` },
    dynamicHighlight: 1,
    suggestedComponentTypes: ['single-shelf', 'DYS'],
  },
  width: 720,
  height: 440,
});

export const createCODwithConfig = (
  disclaimerAdjustment: number,
  isLeftCodPosition = true,
) => ({
  leftOffset: isLeftCodPosition ? 0 : 720,
  topOffset: 1920,
  config: {
    events: {
      COD_COMPLETE: {
        style:
          'transform: translateY(1920px); transition: top 0.7s cubic-bezier(0, 0, 0.2, 1) 0.3s; top: 1920px; z-index: 40;',
      },
      COD_ORDER_OPEN: {
        style: `transition: cubic-bezier(0, 0, 0.2, 1) 0.6s; top: ${
          880 + disclaimerAdjustment
        }px; z-index: 25;`,
      },
      COD_ORDER_EXPAND: {
        style: 'transition: cubic-bezier(0, 0, 0.2, 1); top: 0px; z-index: 25;',
      },
      COD_CONFIRMATION_OPEN: {
        style: `transform: translateY(1920px); transition: top 0.7s cubic-bezier(0, 0, 0.2, 1) 0.1s ${
          isLeftCodPosition ? '' : ', left 0s; transition-delay: 0.1s'
        }; top: -1920px; ${isLeftCodPosition ? '' : 'left: 0px;'} z-index: 49;`,
      },
    },
    initial: { style: 'top: 1920px;' },
    dynamicHighlight: 1,
    suggestedComponentTypes: ['cod'],
  },
  width: 360,
  height: 880,
});

export const TAKEOVER_CONFIG = {
  events: {
    LAYOUT_TIMER: {
      style: 'opacity: 1; transition: opacity 0.5s; z-index: 3;',
    },
  },
  initial: { style: 'opacity:0; z-index: -1;' },
  wrapper: { background: '#000' },
  dynamicHighlight: 3,
};
